import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  PRIZES_ADD_PATH,
  PRIZES_PATH,
  PRIZES_UPDATE_PATH,
} from "utils/constants/paths";

const Prizes = Loadable(React.lazy(() => import("./View")));
const PrizesAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);

export const PrizesRoute: IRouteItem = {
  path: PRIZES_PATH,
  element: React.createElement(Prizes),
  name: "Prizes",
  accessKeys: ["ContentCreator"],
  children: [
    {
      name: "Add / Update",
      path: PRIZES_ADD_PATH,
      element: React.createElement(PrizesAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: PRIZES_UPDATE_PATH,
      element: React.createElement(PrizesAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
